// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"BZ-z","subtitle":"CZ-z","wrapper":"DZ-z","leftArrow":"EZ-z","rightArrow":"FZ-z"};